import React, { useState } from "react";
import axios from "axios";
import "./ChangePassword.css";
import { useAuth } from "../context/AuthContext";

export default function ChangePasswordModal({ onClose }) {

  const { user, logout } = useAuth();

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const handleSubmit = async () => {

    if (!oldPassword || !newPassword || !confirm) {
      return setMsg("⚠ All fields are required");
    }

    if (newPassword !== confirm) {
      return setMsg("❌ New passwords do not match");
    }

    if (newPassword.length < 6) {
      return setMsg("⚠ Password must be at least 6 characters");
    }

    setLoading(true);
    setMsg("");

    try {
      await axios.put(`${process.env.REACT_APP_API_BASE_URL}/superadmin/change-password`, {
        userId: user.id,
        oldPassword,
        newPassword
      });

      setMsg("✅ Password changed successfully");
      setTimeout(() => {
        logout();   // Force re-login
      }, 1500);

    } catch (err) {
      setMsg(err.response?.data?.message || "Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cp-overlay">
      <div className="cp-modal">

        <div className="cp-header">
          <h2>🔐 Change Password</h2>
          <span className="cp-close" onClick={onClose}>×</span>
        </div>

        <div className="cp-body">

          <input
            type="password"
            placeholder="Current Password"
            value={oldPassword}
            onChange={e => setOldPassword(e.target.value)}
          />

          <input
            type="password"
            placeholder="New Password"
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}
          />

          <input
            type="password"
            placeholder="Confirm New Password"
            value={confirm}
            onChange={e => setConfirm(e.target.value)}
          />

          {msg && <div className="cp-message">{msg}</div>}

          <button onClick={handleSubmit} disabled={loading}>
            {loading ? "Updating..." : "Update Password"}
          </button>

        </div>

      </div>
    </div>
  );
}
